<template>
  <main role="main">
      <Cabecera />
      <div class="c-form-info whitebg">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2 c-form-info__wrapper redirect01">
              <div class="c-form-info__validacion">
                <div class="info" v-if="tipoSocDocs.length !== 0">
                  <h2> <strong>REVISA TU CORREO PARA CONTINUAR</strong></h2>
                  <p>Enviamos un correo a <a href="#">{{ emailGlobal }}</a> con tu N° de solicitud.</p>
                  <p>Debes usar ese número para volver a la postulación y subir los documentos obligatorios.</p>
                </div>

                <div class="info" v-if="tipoSocDocs.length == 0">
                  <h2> <strong>REVISA TU CORREO PARA CONTINUAR</strong></h2>
                  <p>Enviamos un correo a <a href="#">{{ emailStorage }}</a> con tu N° de solicitud.</p>
                  <p>Debes usar ese número para volver a la postulación y subir los documentos obligatorios.</p>
                </div>
              </div>
              <div class="c-form-info__documentos">
               <div class="info">
                <h2><font-awesome-icon :icon="['fas', 'triangle-exclamation']" /> <strong>SI NO REALIZAS ESTE PASO, TU POSTULACIÓN QUEDARÁ INCOMPLETA.</strong></h2>
                  <a :href="postType == 2 ? '/docs/ChecklistPN.pdf' : '/docs/ChecklistPJ.pdf'" target="_blank" class="checklist-link">
                    <font-awesome-icon :icon="['fas', 'download']" size="lg" />
                    CheckList documentos que debes cargar a la postulación
                  </a>
                  <br><br><br><br><br><br><br><br></br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
</template>

<script>
import Cabecera from './../components/Cabecera.vue'
import { mapState } from "vuex";

export default {
  name: 'SendSolicitud',
  components: {
    Cabecera,
  },
  data () {
    return {
     text: '',
     emailStorage: '',
     arrayText: [],
     tip: '',
     textPersonaNatural: '',
     item1 : '1. Cuando fueron constituidas según el Régimen Simplificado del Registro de Empresas y Sociedades. ',
     item2 : '2. Cuando fueron constituidas según el Código de Comercio y en sus Leyes especiales. ',

    }
  },
  methods: {


  },

  computed: {
    ...mapState(['emailGlobal', 'resLimitadaDocs', 'socResLimitadaDocs', 'tipoSocDocs', 'postType']),
  },

  created: function () {
    // console.log(this.tipoSocDocs.length);
    // console.log(localStorage.getItem('text'));
    this.text = localStorage.getItem('text');
    // console.log(this.text);
    this.emailStorage = localStorage.getItem('email');
    this.tip = localStorage.getItem('tipSelectSoc');
    // console.log(this.tip);
    
    this.textPersonaNatural = localStorage.getItem('textPN');
    this.arrayText = this.text.split(',');
    // console.log(this.arrayText);
    // console.log(this.postType);
    //window.location.reload(true);
    //window.location.replace('/')
    /*window.onbeforeunload = function(){
      return "Are you sure you want to close the window?";
    }*/
    setTimeout( () => this.$router.push({ path: '/'}), 100000);
  }
}
</script>

<style scoped>
.checklist-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #185bc1;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
}

.checklist-link font-awesome-icon {
  display: inline-flex;
  color: inherit;
  font-size: 1.2em;
}

.checklist-link:hover {
  color: #6c6c6c !important;
}
</style>